"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supply_rule_criteria_schema = exports.supply_rule_route_criteria_schema = exports.supply_rule_match_criteria_schema = exports.supply_rule_list_criteria_schema = exports.supply_rule_base_criteria_schema = exports.supply_rule_match_criteria_property_schema = exports.SupplyRuleMatchCriteriaProperty = exports.supply_rule_list_criteria_property_schema = exports.SupplyRuleListCriteriaProperty = exports.supply_rule_criteria_property_schema = exports.SupplyRuleCriteriaProperty = exports.supply_rule_route_criteria_evaluation_schema = exports.SupplyRuleRouteCriteriaEvaluation = exports.supply_rule_match_criteria_evaluation_schema = exports.SupplyRuleMatchCriteriaEvaluation = exports.supply_rule_list_criteria_evaluation_schema = exports.SupplyRuleListCriteriaEvaluation = exports.supply_rule_criteria_type_schema = exports.SupplyRuleCriteriaType = void 0;
const zod_1 = require("zod");
exports.SupplyRuleCriteriaType = {
    List: "list",
    Match: "match"
};
exports.supply_rule_criteria_type_schema = zod_1.z.nativeEnum(exports.SupplyRuleCriteriaType);
exports.SupplyRuleListCriteriaEvaluation = {
    IsIn: "is in",
    IsNotIn: "is not in"
};
exports.supply_rule_list_criteria_evaluation_schema = zod_1.z.nativeEnum(exports.SupplyRuleListCriteriaEvaluation);
exports.SupplyRuleMatchCriteriaEvaluation = {
    IsExactly: "is exactly",
    StartsWith: "starts with",
    EndsWith: "ends with"
};
exports.supply_rule_match_criteria_evaluation_schema = zod_1.z.nativeEnum(exports.SupplyRuleMatchCriteriaEvaluation);
exports.SupplyRuleRouteCriteriaEvaluation = {
    OriginCountryIsIn: "origin country is in",
    DestinationCountryIsIn: "destination country is in",
    OriginCityIsIn: "origin city is in",
    DestinationCityIsIn: "destination city is in",
    RouteIsIn: "route is in"
};
exports.supply_rule_route_criteria_evaluation_schema = zod_1.z.nativeEnum(exports.SupplyRuleRouteCriteriaEvaluation);
const NonRouteCriteriaProperty = {
    /** The source name */
    Source: "source",
    /** The operator XID */
    Operator: "operator",
    /** The partner ID */
    Partner: "partner",
    /** The Client (iOS, Android, Bookie, PriceCalendar etc) */
    Channel: "channel",
    /** The currency the client is searching in, in ISO3 */
    SearchCurrencies: "search_currencies",
    /** The Point of Sale (where the supply is), in ISO2 */
    PoSu: "PoSu",
    /** The Point of Session (where the client is searching from), in ISO2 */
    PoSe: "PoSe"
};
exports.SupplyRuleCriteriaProperty = Object.assign(Object.assign({}, NonRouteCriteriaProperty), { 
    /** Information about the origin/destination or its combination */
    Route: "route" });
exports.supply_rule_criteria_property_schema = zod_1.z.nativeEnum(exports.SupplyRuleCriteriaProperty);
exports.SupplyRuleListCriteriaProperty = Object.assign({}, NonRouteCriteriaProperty);
exports.supply_rule_list_criteria_property_schema = zod_1.z.nativeEnum(exports.SupplyRuleListCriteriaProperty);
exports.SupplyRuleMatchCriteriaProperty = Object.assign({}, NonRouteCriteriaProperty);
exports.supply_rule_match_criteria_property_schema = zod_1.z.nativeEnum(exports.SupplyRuleMatchCriteriaProperty);
exports.supply_rule_base_criteria_schema = zod_1.z.object({
    property: exports.supply_rule_criteria_property_schema,
    type: exports.supply_rule_criteria_type_schema
});
exports.supply_rule_list_criteria_schema = exports.supply_rule_base_criteria_schema.extend({
    property: exports.supply_rule_list_criteria_property_schema,
    type: zod_1.z.literal(exports.SupplyRuleCriteriaType.List),
    evaluation: exports.supply_rule_list_criteria_evaluation_schema,
    value: zod_1.z.array(zod_1.z.string())
});
exports.supply_rule_match_criteria_schema = exports.supply_rule_base_criteria_schema.extend({
    property: exports.supply_rule_match_criteria_property_schema,
    type: zod_1.z.literal(exports.SupplyRuleCriteriaType.Match),
    evaluation: exports.supply_rule_match_criteria_evaluation_schema,
    value: zod_1.z.string()
});
exports.supply_rule_route_criteria_schema = exports.supply_rule_base_criteria_schema.extend({
    property: zod_1.z.literal(exports.SupplyRuleCriteriaProperty.Route),
    type: zod_1.z.literal(exports.SupplyRuleCriteriaType.List),
    /** Countries in ISO2 format, Cities in UUID format from GrandCentral DB */
    evaluation: exports.supply_rule_route_criteria_evaluation_schema,
    value: zod_1.z.array(zod_1.z.string())
});
exports.supply_rule_criteria_schema = exports.supply_rule_list_criteria_schema
    .or(exports.supply_rule_match_criteria_schema)
    .or(exports.supply_rule_route_criteria_schema);
//# sourceMappingURL=criterias.js.map